import { Wifi } from 'lucide-react';
import { DevToolsEmptyState } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsEmptyState';
import { DevToolsSectionHeader } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsSectionHeader';
import { WebRTCPeerConnectionCard } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/WebRTCTab/WebRTCPeerConnectionCard';
import { WebRTCSupportPanel } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsTabs/WebRTCTab/WebRTCSupportPanel';
import { usePeerConnections } from 'Modules/softphone/components/SoftphoneDevTools/hooks';
import React, { useState } from 'react';

/**
 * WebRTCTab - Is the media path healthy
 */
export const WebRTCTab: React.FC = () => {
  const peerConnections = usePeerConnections();
  const [showClosed, setShowClosed] = useState(false);

  const activeConnections = peerConnections.filter(
    (info) => info.connectionState !== 'closed'
  );
  const closedConnections = peerConnections.filter(
    (info) => info.connectionState === 'closed'
  );
  const displayedConnections = showClosed ? peerConnections : activeConnections;

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-2">
        <DevToolsSectionHeader
          title="Peer connections"
          count={activeConnections.length}
        />
        <div className="flex-1" />
        {closedConnections.length > 0 && (
          <button
            type="button"
            onClick={() => setShowClosed(!showClosed)}
            className="flex-shrink-0 rounded-[5px] border border-zinc-800 px-[7px] py-[3px] text-[10.5px] text-zinc-400 transition-colors hover:border-zinc-700 hover:text-zinc-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-400/40"
          >
            {showClosed ? 'Hide' : 'Show'} closed ({closedConnections.length})
          </button>
        )}
      </div>

      {displayedConnections.length > 0 ? (
        displayedConnections.map((info) => (
          <WebRTCPeerConnectionCard key={info.callId} info={info} />
        ))
      ) : (
        // The empty state names the labels a connection will carry, so the
        // model is learnable while idle rather than only mid-transfer.
        <DevToolsEmptyState
          icon={<Wifi className="h-[21px] w-[21px]" strokeWidth={1.7} />}
          title="No media path open"
          body="One card per peer connection appears here: its connection, ICE and signalling state, the offer/answer types, each side's candidate count, and the raw SDP."
          chips={[
            'original:<call-id>',
            'consultation:<call-id>',
            'conference:<room-guid>',
          ]}
        />
      )}

      <WebRTCSupportPanel />
    </div>
  );
};
